var _style, _rect, _circle, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasActuatorPoweredbyFluidGas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 3.1,
    className: "st0",
    width: 9.3,
    height: 9.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 6.5,
    cy: 10.1,
    r: 1.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.6,
    y1: 8,
    x2: 10.7,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.2,
    y1: 8,
    x2: 12.3,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 8,
    x2: 14.1,
    y2: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.7,
    y1: 8,
    x2: 15.8,
    y2: 8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.6,
    y1: 3.1,
    x2: 12.3,
    y2: 3.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasActuatorPoweredbyFluidGas);
export default __webpack_public_path__ + "static/media/GasActuatorPoweredbyFluidGas.ee123a6fe2c42969e9f68e5a9e4b4a11.svg";
export { ForwardRef as ReactComponent };